<template>
	<el-aside class="admin-aside" width="240px">
		<div class="logo">燃气报警云监控平台</div>
		<div class="admin-menu-list" style="">
			<div style="position: relative;height: 100%;width: 100%;">
				<div class="search-menu">
					<el-input style="width: 80%;" v-model="areaName" placeholder="搜索">
					</el-input>
				</div>
				<ul class="menu-list">
					<li :class="{on:menuActive == 'all'}" @click="getAllArea('all')"><span>全部</span></li>
					<li :class="{on:menuActive == index}" v-for="(item,index) in areaList" :index="index" :key="index">
						<span @click="clickAreaParent(index)">{{index}}</span>
						<ul v-if="menuOpen == index">
							<li :class="{on:menuActive == item1.district}" v-for="(item1,index1) in item" :index="index1" :key="index1">
								<span @click="clickArea(item1)">{{item1.district}}</span>
							</li>
						</ul>
					</li>
				</ul>
			</div>
		</div>
	</el-aside>
</template>

<script>
	import CommonJs from "@/assets/js/common/common.js";
	export default {
		name: 'AdminMenu',
		data() {
			return {
				menuActive: 'all',
				menuOpen: 'all',
				areaList: [],
				areaName: '',
				selectList: '',
				searchMenu: {},
			}
		},
		watch: {
			areaName(newVal, oldVal) {
				var param = {
					areaName: newVal,
				};
				CommonJs.getAreaNameList(param).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.areaList = data.data;
						this.selectList = [];
						let i = 0;
						for (let item in this.areaList) {
							this.areaList[item].forEach((item1, index) => {
								this.$parent.$parent.queryArea(item1);
								this.selectList.push(item1);
							})

						}
					}
				})
			},
		},
		methods: {
			getArea() {
				var param = {};
				CommonJs.getAreaNameList(param).then((response) => {
					const data = response.data;
					if (data.code == 1) {
						this.areaList = data.data;
						this.selectList = [];
						let i = 0;
						for (let item in this.areaList) {
							this.areaList[item].forEach((item1, index) => {
								this.selectList.push(item1);
							})

						}
					}
				})
			},

			getAllArea(item) {
				this.menuActive = item;
				this.menuOpen = item;
				this.$parent.$parent.queryArea({
					city: item
				}, item.lng, item.lat);
				//test(item);
			},
			clickAreaParent(item) {
				this.menuActive = item;
				this.menuOpen = item;
				this.$parent.$parent.queryArea({
					city: item
				}, item.lng, item.lat);
				//test(item);
			},
			clickArea(item) {
				this.menuActive = item;
				let mes = [];
				mes.push(item.district)
				this.$parent.$parent.queryArea({
					district: mes
				}, item.lng, item.lat);
				//test(item);

			},

		},
		created() {
			this.getArea();
			if (sessionStorage.getItem('store')) {
				this.$store.replaceState(Object.assign({}, this.$store.state, JSON.parse(sessionStorage.getItem('store'))))
			}
		},
		mounted() {},
	}
</script>

<style>
	.menu-list {
		width: 100%;
		color: #fff;
		font-size: 14px;
	}

	.menu-list>li {
		width: 100%;
	}

	.menu-list>li>span:hover {
		width: 100%;
		background-color: #1A2630;
	}

	.menu-list>li>span {
		display: flex;
		align-items: center;
		height: 50px;
		padding: 0 20px;
	}

	.menu-list>li.on>span {
		color: #43DC7D;
		background-color: #1A2630;
	}

	.menu-list>li>ul {
		width: 100%;
	}

	.menu-list>li>ul>li {
		width: 100%;
	}

	.menu-list>li>ul>li>span:hover {
		width: 100%;
		background-color: #1A2630;
	}

	.menu-list>li>ul>li>span {
		display: flex;
		align-items: center;
		height: 50px;
		padding: 0 40px;
	}

	.menu-list>li>ul>li.on>span {
		color: #43DC7D;
		background-color: #1A2630;
	}

	.search-menu {
		height: 50px;
		display: flex;
		align-items: center;
		justify-content: center;
	}

	.search-menu .el-input__inner {
		height: 30px;
		line-height: 30px;
		border: 0;
		background-color: #434A61;
		color: #f5f5f5;
		border-radius: 15px;
	}
</style>



// WEBPACK FOOTER //
// src/components/common/menu.vue